<template>
  <div class="createPost-container">
    <el-form
      ref="form"
      :model="form"
      :rules="Object.keys(fields).reduce((rules, key) => ((rules[key] = fields[key].rules), rules), {})"
      class="form-container"
      label-width="150px"
      :label-position="formLabelPosition"
    >
      <sticky v-if="saveButtonPosition === 'top'" :class-name="'sub-navbar '">
        <slot>
          <editor-button v-if="!disabled" :loading="actionLoading" action="save" @click="handleSave" />
          <editor-button v-if="!disabled" :loading="actionLoading" action="saveClose" @click="saveAndClose" />
          <editor-button :loading="actionLoading" action="cancel" @click="close" />
        </slot>
      </sticky>
      <div v-loading="pageLoading" class="createPost-main-container">
        <el-alert v-if="disabled" :title="$t('permission.pageIsReadonly')" type="info" :closable="false" />
        <el-row :gutter="20">
          <el-col
            v-for="(columnFields, index) in columnsFields"
            :key="index"
            :xs="24"
            :lg="24 / (isEmbedded ? 1 : columnsFields.length)"
          >
            <el-row v-for="(spec, name) in columnFields" :key="name">
              <el-col v-if="isEdit || !spec.hideOnCreate">
                <el-form-item
                  :prop="name"
                  :label="(spec.props.caption && $t(`${spec.props.caption}`)) || $t(`common.${name}`)"
                >
                  <component
                    :is="spec.type"
                    v-model="form[name]"
                    v-bind="spec.props"
                    :disabled="disabled || !!spec.props.disabled"
                    :maxlength="spec.props.maxlength"
                    :name="name"
                    :required="!!spec.props.required"
                    @init="
                      initialVal => {
                        handleInit(name, initialVal);
                      }
                    "
                    @input="delete errors[name]"
                  >
                  </component>
                  <input-errors :errors="errors[name.toLowerCase()]" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <sticky v-if="saveButtonPosition === 'bottom'" :class-name="'sub-navbar '">
        <editor-button v-if="!disabled" :icon-only="false" :loading="actionLoading" action="save" @click="handleSave" />
      </sticky>
    </el-form>
  </div>
</template>

<script>
import Sticky from '@/components/Sticky'; // Sticky header-component
import InputErrors from '@/components/DSE/InputErrors';
import editorMixin from './mixins/editor-mixin';
import EditorButton from './EditorButton';

export default {
  components: {
    Sticky,
    EditorButton,
    InputErrors
  },
  mixins: [editorMixin]
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '~@/styles/mixin.scss';

.createPost-container {
  position: relative;

  .createPost-main-container {
    padding: 40px 45px 20px 50px;

    .postInfo-container {
      position: relative;
      @include clearfix;
      margin-bottom: 10px;

      .postInfo-container-item {
        float: left;
      }
    }
  }

  .word-counter {
    width: 40px;
    position: absolute;
    right: -10px;
    top: 0px;
  }
}
.el-dialog {
  .el-dialog__body {
    .createPost-container {
      .createPost-main-container {
        padding: 0px;
      }
    }
  }
}

.input-error {
  display: block;
  color: #f56c6c;
  padding-top: 4px;
  position: relative;
  font-size: 12px;
  line-height: 16px;
}
</style>
